<template>
	<section>
		<section v-bind:class="editing ? '' : ''">
			<b-row v-if="(!editing && !hideSelectInterval) || !hideSelectSendMsg" class="mt-3 filters-orientation" v-bind:class="editing ? '' : ''">
				<b-col v-if="!editing && !hideSelectInterval" class="text-parcela">
					<label class="label-conta mb-0">Intervalo em días / dia do mes</label>
					<div style="display: flex !important; align-items: center; margin-top: -7px !important;">
						<div class="toggle-div mr-3">
							<ToggleSwitch
								name="dayOfMonth"
								class="toggle"
								:value="dayOfMonth"
								@toggle="_ => changeToggle('dayOfMonth')"
							/>
						</div>
						<b-form-input
							name="day"
							class="modal-edicao-input number-class"
							type="number"
							v-model="day"
							autocomplete="off"
							placeholder=""
							min="1"
							v-validate="{ required: true, min_value: 1 }"
							:state="validateState('day')"
							:disabled="editing"
							@focus="handleFocus('day')"
							@input="calculateInstallments"
						/>
					</div>
				</b-col>
				<b-col v-if="!hideSelectSendMsg" class="text-parcela">
					<label class="label-conta mb-0">Ativar mensagem cobrança</label>
					<div style="display: flex !important; align-items: center; margin-top: -4px !important;">
						<div class="toggle-div mr-3">
							<ToggleSwitch
								name="sendMsg"
								class="toggle"
								:value="sendMsg"
								@toggle="_ => changeToggle('sendMsg')"
							/>
						</div>
					</div>
				</b-col>
			</b-row>
			<b-row class="mt-3 filters-orientation" v-bind:class="editing ? '' : ''">
				<b-col v-if="partialReceive" class="d-block text-parcela mb-3">
					<span class="label-conta">Recebido</span>
					<b-form-input
						name="receive_amount_string"
						class="modal-edicao-input number-class"
						v-model="receive_amount_string"
						autocomplete="off"
						placeholder=""
						inputmode="numeric"
						v-validate="`required|notGreaterThan:${this.totalAmount - 0.01}|${this.otherValidations}`"
						:state="validateState('receive_amount_string')"
						:disabled="false"
						@input="setOutstandingBalance"
						@focus="handleFocus('receive_amount_string')"
						@blur="handleBlur('receive_amount_string')"
					/>
				</b-col>
				<b-col v-if="partialReceive" class="d-block text-parcela mb-3">
					<span class="label-conta">Saldo Pendente</span>
					<b-form-input
						name="amount_string"
						class="modal-edicao-input number-class"
						v-model="amount_string"
						autocomplete="off"
						placeholder=""
						inputmode="numeric"
						v-validate="'required|noZeroCurrency'"
						:state="validateState('amount_string')"
						:disabled="disableAmount"
					/>
				</b-col>
				<b-col v-else class="d-block text-parcela mb-3">
					<span class="label-conta">Valor</span>
					<b-form-input
						name="valor"
						class="modal-edicao-input number-class"
						v-model="amount_string"
						autocomplete="off"
						placeholder=""
						inputmode="numeric"
						v-validate="'required|noZeroCurrency'"
						:state="validateState('valor')"
						@input="updateValue()"
						@focus="handleFocus('amount_string')"
						@blur="handleBlur('amount_string')"
						:disabled="disableAmount"
					/>
				</b-col>
				<b-col v-if="!editing && !hideInstallment" class="d-block text-parcela">
					<span class="label-conta">Parcelas</span>
					<b-form-input
						name="installments"
						class="modal-edicao-input number-class"
						type="number"
						v-model="installments"
						autocomplete="off"
						placeholder=""
						min="1"
						v-validate="{ required: true, min_value: 1 }"
						:state="validateState('installments')"
						:disabled="editing || disableInstallment"
						@focus="handleFocus('installments')"
						@input="calculateInstallments"
					/>
				</b-col>
			</b-row>
		</section>
		<section
			v-if="!editing && !disableInstallment && !hideInstallment"
			class="label-table mt-3" style="height: 16rem; overflow: hidden;"
		>
			<div style="padding: 3px 0; max-height: 15rem">
				<table class="ml-1" style="width: calc(100% - 8px);">
					<thead class="mt-1 mb-1">
						<tr>
							<th style="width: 18%;">
								Parcela
							</th>
							<th style="width: 38%;">
								Vencimento
							</th>
							<th style="width: 40%;">
								Valor
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="i in parseInt(installments || 1)" :key="i">
							<td class="mr-1" style="width: 17%;"><span class="label-parcela ml-1"># {{ i }}</span></td>
							<td class="mr-2" style="width: 38%;">
								<b-form-input class="modal-edicao-input number-class"
									:name="`date-${i}`"
									v-model="date_installments[i - 1]"
									v-validate="'required|isDate'"
									:state="validateState(`date-${i}`)"
									@blur="validateDate(date_installments[i - 1])"
									:disabled="dateDisabled"
								/>
							</td>
							<td style="width: 38%;">
								<b-form-input
									:name="`amount-${i}`"
									class="modal-edicao-input number-class"
									v-model="amount_installments_string[i - 1]"
									autocomplete="off"
									placeholder=""
									:state="validateState(`amount-${i}`)"
									v-validate="'required|noZeroCurrency'"
									inputmode="numeric"
									@input="setNewValue(amount_installments_string[i - 1], i - 1)"
									:disabled="((!installments || installments == 1) && blockAmount) && !enableValueWithOneInstallment"
									@focus="handleFocus('amount_installments_string', i - 1)"
									@blur="handleBlur('amount_installments_string', i - 1)"
								/>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</section>
	</section>
</template>

<script>
	import { numberFormatted, validateNumber, stringToNumber, isNullValue, isDateString } from "@/helpers/common";
	import { hasFieldsWithErrors } from "@/helpers/validators";
	import dayjs from "dayjs";
	import "dayjs/locale/pt-br";
	import { ptBR } from "vuejs-datepicker/dist/locale";
	import ToggleSwitch from "@/components/ToggleSwitch.vue";

	export default {
		name: "Installment",
		components: {
			ToggleSwitch
		},
		props: {
			editing: {
				type: Boolean,
				required: false,
				default: false
			},
			date: {
				type: Date,
				required: true
			},
			update: {
				type: Boolean,
				required: true
			},
			dateIsFirstInstallment: {
				type: Boolean,
				required: false,
				default: false
			},
			dateDisabled: {
				type: Boolean,
				required: false,
				default: false
			},
			blockAmount: {
				type: Boolean,
				required: false,
				default: true
			},
			disableAmount: {
				type: Boolean,
				required: false,
				default: false
			},
			disableInstallment: {
				type: Boolean,
				required: false,
				default: false
			},
			hideAmount: {
				type: Boolean,
				required: false,
				default: false
			},
			hideSelectInterval: {
				type: Boolean,
				required: false,
				default: false
			},
			hideSelectSendMsg: {
				type: Boolean,
				required: false,
				default: false
			},
			hideDay: {
				type: Boolean,
				required: false,
				default: false
			},
			hideInstallment: {
				type: Boolean,
				required: false,
				default: false
			},
			totalAmount: {
				type: Number,
				required: false,
				default: 0
			},
			partialReceive: {
				type: Boolean,
				required: false,
				default: false
			},
			enableValueWithOneInstallment: {
				type: Boolean,
				required: false,
				default: false
			},
			sendLatePaymentMessage: {
				type: Boolean,
				required: false,
				default: false
			},
			dayPay: {
				type: Number,
				required: false,
				default: 1
			},
			clearFields: {
				type: Boolean,
				required: false,
				default: false
			},
			otherValidations:{
				type: String,
				required: false,
				default: "|noZeroCurrency"
			}
		},

		data () {
			return {
				ptBR,
				amount_installments: [],
				amount_installments_string: [],
				date_installments: [],
				errors: false,
				amount_string: "0,00",
				amount: 0,
				day: "1",
				dayOfMonth: false,
				sendMsg: false,
				installments: "1",
				total: 0,
				receive_amount_string: "0,00",
				receive_amount: 0,
				toReceiveDataInstallments: []
			};
		},

		watch: {
			sendLatePaymentMessage () {
				this.sendMsg = this.sendLatePaymentMessage;
			},
			totalAmount () {
				this.amount = this.totalAmount - this.receive_amount;
				this.amount_string = numberFormatted(this.amount);

				if (!this.editing) this.calculateInstallments();
			},
			date: "setDate",
			dayPay (newDay) {
				this.day = newDay;
				if (this.disableInstallment)
					this.installments = "1";

				this.calculateInstallments();
			},
			clearFields () {
				if (!this.clearFields) return;

				this.amount = 0;
				this.amount_string = numberFormatted(this.amount);
				this.day = "1";
				this.dayOfMonth = this.hideSelectInterval;
				this.sendMsg = false;
				this.installments = "1";

				this.calculateInstallments();
			}

		},

		async mounted () {
			this.dayOfMonth = this.hideSelectInterval;
			this.day = this.dayPay;
			this.amount = !this.clearFields ? this.totalAmount : 0;
			this.amount_string = numberFormatted(this.amount);
			this.sendMsg = this.sendLatePaymentMessage;
			this.calculateInstallments();
		},

		methods: {
			changeToggle (key) {
				this[key] = !this[key];
				if (key === "dayOfMonth") {
					this.calculateInstallments();
				} else {
					this.emitDataInstallment();
				}
			},

			setDate () {
				this.calculateInstallments();
			},

			setAmount () {
				if (!this.update) return;

				this.calculateInstallments();
			},

			async setOutstandingBalance () {
				if (!this.receive_amount_string) return;

				this.receive_amount_string = await validateNumber(this.receive_amount_string);
				this.receive_amount = stringToNumber(this.receive_amount_string);
				this.amount = (parseFloat(this.totalAmount - this.receive_amount).toFixed(2));
				this.amount_string = numberFormatted(this.amount);
				this.calculateInstallments();

			},

			async calculateInstallments () {
				if (!this.installments || !this.day || !this.amount_string) return;

				const _amount = stringToNumber(this.amount_string);

				let valorParcela = parseFloat((_amount / this.installments).toFixed(2));
				let somaTotal = 0;
				this.amount_installments = [];
				this.date_installments = [];
				this.amount_installments_string = [];
				this.toReceiveDataInstallments = [];

				const dateNextPayment = new Date(this.date);
				const today = parseInt(dateNextPayment.getDate());
				let month = parseInt(dateNextPayment.getMonth());
				let year = parseInt(dateNextPayment.getFullYear());

				for (let parcela = 1 ; parcela <= parseInt(this.installments) ; parcela++) {
					if (parcela === parseInt(this.installments))
						valorParcela = parseFloat((_amount - somaTotal).toFixed(2));

					somaTotal = somaTotal + valorParcela;
					this.amount_installments.push(valorParcela);
					this.amount_installments_string.push(numberFormatted(valorParcela));
					if (!this.dayOfMonth) {
						dateNextPayment.setDate(dateNextPayment.getDate() + parseInt(this.day));
					} else {
						if (parcela > 1 || (today >= parseInt(this.day) && !this.dateIsFirstInstallment)) {
							month = month + 1;
							if (month > 11) {
								month = 0;
								year = year + 1;
							}
						}

						dateNextPayment.setDate(this.day);
						dateNextPayment.setMonth(month);
						dateNextPayment.setFullYear(year);
					}

					this.date_installments.push(dayjs(dateNextPayment).locale("pt-br").format("DD-MM-YYYY"));
				}
				this.emitDataInstallment();
			},

			async setNewValue (_value, index) {
				if (!_value) return;

				this.internalUpdatedOutstandingBalance = true;
				this.amount_installments_string[index] = await validateNumber(_value);
				this.amount_installments[index] = this.amount_installments_string[index].replace(",", ".");
				let somaTotal = 0;
				this.amount_installments.forEach(amount => {
					const valorParcela = parseFloat(amount);

					somaTotal = somaTotal + valorParcela;
				});
				const value = somaTotal.toFixed(2);
				this.amount = value;
				this.amount_string = numberFormatted(value);
				this.emitDataInstallment();
			},

			validateState (ref) {
				const outstandingBalance = this.amount;
				let errorAmountMin = parseFloat((this.totalAmount - this.receive_amount).toFixed(2)) > outstandingBalance;
				if (this.editing)
					errorAmountMin = false;

				this.errors = hasFieldsWithErrors(this.veeFields) || errorAmountMin;
				this.$emit("errorInstallments", this.errors);

				if (
					this.veeFields[ref]
					&& (this.veeFields[ref].dirty || this.veeFields[ref].validated)
				) {
					return !this.veeErrors.has(ref);
				}

				return null;
			},

			async updateValue () {
				if (!this.amount_string) return;

				this.amount_string = await validateNumber(this.amount_string);
				this.amount = this.amount_string.replace(".", "");
				this.amount = this.amount_string.replace(",", ".");
				this.calculateInstallments();
			},

			handleFocus (key, index) {
				if (index !== undefined) {
					if (isNullValue(this[key][index])) {
						this.$set(this[key], index,
							this[key][index] = ""
						);
					} else if (typeof this[key][index] === "string") {
						this.$set(this[key], index,
							this[key][index] = this[key][index].replace(/\./g, "")
						);
					}
				} else {
					if (isNullValue(this[key])) {
						this[key] = "";
					} else {
						if (typeof this[key] === "string")
							this[key] = this[key].replace(/\./g, "");
					}
				}
			},

			handleBlur (key, index) {
				if (index !== undefined) {
					if (this[key][index]) {
						this.$set(this[key], index,
							this[key][index] = numberFormatted(stringToNumber(this[key][index]))
						);
					}
				} else {
					this[key] = this[key] && numberFormatted(stringToNumber(this[key]));
				}

			},

			emitDataInstallment () {
				const toReceiveDataInstallments = [];
				for (let idx = 0; idx < this.installments; idx++) {
					toReceiveDataInstallments.push({
						toReceiveDate: this.date_installments[idx],
						amount: this.amount_installments[idx]
					});
				}

				const dataInstallments = {
					day: this.day,
					sendMsg: this.sendMsg,
					installments: this.installments,
					totalAmount: this.totalAmount,
					receivedAmount: this.receive_amount,
					dayOfMonth: this.dayOfMonth,
					outstandingBalance: this.amount,
					toReceiveDataInstallments
				};
				this.$emit("dataInstallments", dataInstallments);
			},

			validateDate (date) {
				if (isDateString(date))
					this.emitDataInstallment();
			}
		}
	};
</script>

<style scoped>
	.flex-edit {
		display: flex;
		justify-content: space-between;
	}

	table {
		border-collapse: collapse;
		width: 100%;
	}

	thead, tfoot {
		background-color: #eee;
	}

	tbody {
		display: block;
		max-height: 200px; /* Ajusta la altura máxima aquí */
		overflow-y: scroll;
	}

	thead, tfoot {
		display: table;
		width: 100%;
		table-layout: fixed; /* Para que coincidan los anchos */
	}

	tbody tr {
		display: table;
		width: 100%;
		table-layout: fixed;
		background-color: #fff;
	}

</style>